var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormAudioguide", {
                attrs: {
                  data: _vm.audioguide,
                  cities: _vm.cities,
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  isNew: !_vm.id,
                  dictionaries: _vm.dictionaries,
                  language: _vm.language,
                },
                on: {
                  "delete-audioguide": _vm.deleteAudioguide,
                  submit: _vm.audioguideSubmitHandle,
                  cancel: function ($event) {
                    return _vm.$router.push({ name: "page-audioguides" })
                  },
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  "change:descriptionForMobile": function ($event) {
                    return _vm.changeDescForMobHandler($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmAudioguideRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }